import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../../Structure/components/Head/Head';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../Alerts/AlertsConteiner';
import Input from '../../Forms/input/input';
import InputTextarea from '../../Forms/input/InputTextarea';
import {browserHistory} from 'react-router';
import WaitBlock from "../../Alerts/WaitBlock";
import {changeStepWaitBlock, showWaitBlock} from "../../../../Structure/actions/actionsStructure";
import {checkIsLogin} from '../../../../AdminProtectora/actions/actionsAdmin'
import {sendContactEmail} from "../../../actions/actionsContactByEmail";
import PoliticaCheckButton from '../../components/PoliticaCheckButton/PoliticaCheckButton';
import {PATH_BUSCADOR_ANIMALES_ADMIN} from "../../../../../App/RouterAdopta";

class ContactUsLandingPage extends Component {

    constructor(props) {
        super(props);
        this.props.isLogin();

        this.state = {
            name: "",
            email: "",
            content: "",
            okPolitica: false
        };

        this.name = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateLogin",
            iconSpan: "icon-registro las la-user",
            columns: "col-lg-12",
            id: "name",
            type: "text",
            placeHolder: "*Nombre",
            methodChange: this.changeName.bind(this)
        };

        this.email = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-envelope",
            columns: "col-lg-12",
            id: "email",
            type: "text",
            placeHolder: "*Email",
            methodChange: this.changeEmail.bind(this)
        };

        this.content = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            iconSpan: "icon-registro las la-file-alt",
            controlValidate: "validateRegis",
            columns: "col-lg-12",
            id: "content",
            formGroup: "",
            rows: "5",
            placeHolder: "*Escriba aquí su comentario",
            methodChange: this.changeContent.bind(this)
        };

        this.EventWaitBlock = this.EventWaitBlock.bind(this);
        this.send = this.send.bind(this);
        this.handleOkPolitica = this.handleOkPolitica.bind(this);
    }

    changeName(value) {
        this.setState({
            name: value
        });
    }

    changeEmail(value) {
        this.setState({
            email: value
        });
    }

    changeContent(value) {
        this.setState({
            content: value
        });
    }

    handleOkPolitica(checked) {
        this.setState({
            okPolitica: checked
        });
    }

    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    send(e) {
        //Comprobar que todos los campos son correctos.
        let errorMessage = "";
        const name = $('#name');
        const email = $('#email');
        const content = $('#content');


        name.removeClass('formInputError');
        email.removeClass('formInputError');
        content.removeClass('formInputError');

        if (name.val() === "") {
            name.addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Nombre";
            } else {
                errorMessage += ", nombre";
            }
        }

        if (!this.props.access.isLogin || !this.props.access.user) {
            if (email.val() === "") {
                email.addClass('formInputError');
                if (errorMessage === "") {
                    errorMessage = "Email";
                } else {
                    errorMessage += ", email";
                }
            } else if (!this.validateEmail(email.val().trim())) {
                email.addClass('formInputError');
                if (errorMessage === "") {
                    errorMessage = "Email no válido";
                } else {
                    errorMessage += ", email no válido";
                }
            }
        }

        if (content.val() === "") {
            content.addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Mensaje";
            } else {
                errorMessage += ", mensaje";
            }
        }

        Alert.closeAll();
        if (errorMessage !== "") {
            e.preventDefault();
            Alert.warning('Los siguientes campos son obligatorios: ' + errorMessage, {
                position: 'top-right',
                effect: 'slide',
                timeout: 3000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle"
                }
            });
        } else {
            e.preventDefault();
            this.props.changeWaitBlock(true);
        }
    }

    EventWaitBlock(event) {
        if (event === "go") {
            this.props.sendContactEmail(this.state, this.props.access);
        } else {
            if (this.props.stepWaitBlock === 201) {
                Alert.success('Enviado correctamente', {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-thumbs-up"
                    }
                });
            } else {
                Alert.error('Error: ' + this.props.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });
            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }
    }

    goHome() {
        const animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        // $('.page-login').removeClass('animated-400ms fadeIn').addClass('animated-400ms fadeOut').one(animationEnd, () => {

        if(this.props.access.isLogin){
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN + '?utm_medium=contactaConNosotros');
        }else{
            browserHistory.push('/?utm_source=buscador&utm_medium=contactaConNosotros');
        }
        // });
    }

    render() {
        return (
            <div>
                <Head
                    previousPath={"contact"}
                />
                {this.props.showWaitBlock &&
                <WaitBlock
                    message={"Enviando. Espere por favor..."}
                    methodChange={this.EventWaitBlock}
                />
                }
                <div className="page-login main-content">
                    <div className="container">
                        <div className="page-login__wrap">
                            {this.props.access.isLogin &&
                            <h2 className="page-login__heading">Contactar con soporte al cliente</h2>
                            }
                            {!this.props.access.isLogin &&
                            <h2 className="page-login__heading">Contacta con nosotros</h2>
                            }
                            <br/>
                            <h4 className="page-login__subtitle">Escríbenos siempre que desees, estaremos encantandos de atenderte 😊</h4>
                            <p className="page-login__description">
                                <br/>
                                Recuerda que nosotros no gestionamos ningún animal (no tenemos animales a nuestro cuidado ni de las protectoras)
                                <br/>
                                <br/>
                                Si tu consulta es sobre animales o como ayudar a una protectora contacta con tu protectora más cercana
                            </p>
                            <form action="#" className="page-login__form">
                                {!this.props.access.isLogin &&
                                <div className="row justify-content-center">
                                    <div className="page-login-text">
                                        <div className="page-login-titulo">Usaremos estos datos para ponernos en
                                            contacto contigo
                                        </div>
                                    </div>
                                    <Input
                                        configInput={this.name}
                                    />
                                </div>
                                }
                                {this.props.access && this.props.access.isLogin && this.props.access.user &&
                                <div className="page-login-text">
                                    <div className="page-login-titulo">Usaremos el email <span
                                        className="email-admin-contact-landing">{this.props.access.user}</span> para
                                        ponernos en contacto contigo
                                    </div>
                                </div>
                                }
                                {(!this.props.access || !this.props.access.isLogin || !this.props.access.user) &&
                                <div className="row justify-content-center">
                                    <Input
                                        configInput={this.email}
                                    />
                                </div>
                                }
                                <div className="row justify-content-center">
                                    <InputTextarea
                                        configTextArea={this.content}
                                    />
                                </div>
                                {this.props.access && !this.props.access.isLogin &&
                                <div className="row justify-content-center col-lg-12">
                                    <PoliticaCheckButton onOkPolitica={this.handleOkPolitica}/>
                                </div>
                                }
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary btn-block page-login__submit-btn"
                                                    type="button" onClick={this.send}
                                                    disabled={(!this.props.access.isLogin && !this.state.okPolitica)}>Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <footer className="page-login__form-footer">
                                    <a href="#" onClick={() => this.goHome()}
                                       className="btn btn-outline-secondary page-login__signup-btn">Ir a página
                                        principal</a>
                                </footer>
                            </form>
                        </div>
                    </div>
                </div>
                <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
            </div>
        );
    }

    componentWillMount() {
        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({
                scrollTop: element.offset().top
            }, 100);
        }

        this.props.changeWaitBlock(false);
        this.props.changeStepWaitBlock(0);
    }

    componentDidMount() {
        $('.page-login').addClass('animated-100ms fadeIn');
        $('.page-login').show();
        let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        if (!this.props.showHead) {
            // $('.header-topbar').addClass('animated-400ms fadeInDown').one(animationEnd, () => {
            //     $('.header-topbar').removeClass('animated-400ms fadeInDown');
            // });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            // $('.header-topbar').removeClass('animated-400ms fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }

        if (!this.props.showFooter) {
            // $('.footer-default').addClass('animated-400ms fadeIn');
            $('.footer-default').show();
        } else {
            // $('.footer-default').removeClass('animated-400ms fadeIn');
            $('.footer-default').show();
        }

        //$('#user').focus();

    }

    componentDidUpdate() {
        if (this.props.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass("one");
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }

}

function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,
        errorWaitBlock: state.structureControl.errorWaitBlock,
        access: state.access,
    }
}

export default connect(mapStateToProps, {
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    sendContactEmail,
    isLogin: checkIsLogin
})(ContactUsLandingPage)
